<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                CONTRATO -
                <strong
                    >{{ contrato.vcCodigoEstruturado }} -
                    {{
                        contrato.fornecedor ? contrato.fornecedor.nome : ''
                    }}</strong
                >
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Funcionário</label>
                        <b-form-select
                            :options="funcionarios"
                            v-model="codFuncionario"
                            text-field="nome"
                            value-field="codFuncionario"
                            @input="$v.codFuncionario.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Responsabilidade</label>
                        <b-form-select
                            :options="responsabilidades"
                            v-model="responsabilidadeId"
                            text-field="descricao"
                            value-field="responsabilidadeId"
                            @input="$v.responsabilidadeId.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvarResponsavel()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'

export default {
    data() {
        return {
            contrato: {},
            erros: [],
            operacao: 'RESPONSÁVEIS',
            codFuncionario: null,
            responsabilidadeId: null,
            funcionarios: [],
            responsabilidades: []
        }
    },

    methods: {
        voltar() {
            this.erros = []
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        confirmaSalvarResponsavel() {
            this.$swal({
                title: 'Responsável pelo Contrato',
                html: `Confirma a responsabilidade pelo o contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarResponsavel()
                }
            })
        },

        salvarResponsavel() {
            this.$store.dispatch('addRequest')
            let responsavelDto = {
                idContrato: this.contrato.idContrato,
                idResponsavelContrato: this.contrato.idResponsavelContrato,
                codFuncionario: this.codFuncionario,
                responsabilidadeId: this.responsabilidadeId
            }
            ContratosServicos.atualizarResponsavel(responsavelDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorIdReponsavel(
                this.$route.params.contratoId,
                this.$route.params.responsavelId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencheFormulario(data) {
            this.contrato = data
            this.responsabilidades = data.responsabilidades
            this.funcionarios = data.funcionarios
            this.codFuncionario = data.codFuncionario
            this.responsabilidadeId = data.responsabilidadeId
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.voltar()
        },

        registrosInalterados() {
            return (
                this.codFuncionario == this.contrato.codFuncionario &&
                this.responsabilidadeId == this.contrato.responsabilidadeId
            )
        }
    },

    created() {
        this.obterContrato()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {},

    validations: {
        idContrato: {
            contratoAlterado() {
                return !this.registrosInalterados()
            }
        },
        codFuncionario: {
            required
        },
        responsabilidadeId: {
            required
        }
    },

    components: {}
}
</script>
